import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./adminLogin.css";

const API_BASE = "https://dev-api.sulavsewanepal.com";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();

  // static credentials
  const staticEmail = "sulavsewa4@gmail.com";
  const staticPassword = "admin@sulav123";

  if (email === staticEmail && password === staticPassword) {
    localStorage.setItem("token", "dummy-token");
    localStorage.setItem("isAdmin", "true");

    navigate("/");
  } else {
    alert("Invalid email or password");
  }
};

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const res = await fetch(`${API_BASE}/api/auth/login`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ email, password }),
  //     });

  //     const data = await res.json();

  //     if (res.ok) {
  //       // store token
  //       localStorage.setItem("token", data.token);
  //       localStorage.setItem("isAdmin", "true");

  //       navigate("/");
  //     } else {
  //       alert(data.message || "Login failed");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     alert("Server error");
  //   }
  // };

 return (
  <div className="login-wrapper">
    
    {/* LEFT SIDE */}
    <div className="login-left">
      <img src="/logo/updated-logo.png" alt="logo" />
      <h1>Sulav Sewa Nepal</h1>
      <p>Admin Panel</p>
    </div>

    {/* RIGHT SIDE */}
    <div className="login-right">
      <div className="login-box">
        <h2>Admin Login</h2>

        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">Login</button>
        </form>
      </div>
    </div>

  </div>
);
};
export default AdminLogin;